export const question_type=[
    {
        name:'选择题',
        child:[
            {
                name:'单选题',
                icon:'',
                i_icon:'\ue735',
                class:'my_span3',
                template:{text:"",type:"单选",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:0,point:0},
                        {text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:1,point:0}]},
            },
            {
                name:'多选题',
                icon:'',
                i_icon:'\ue738',
                class:'my_span3',
                template:{text:"",type:"多选",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:0,point:0},
                        {text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:1,point:0}]},
            },
            {
                name:'单选文本',
                icon:'',
                i_icon:'\ue734',
                class:'',
                template:{text:"",type:"单选文本",pictureUrl:"",required:true,index:"",key:0,textPoint:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:0,point:0},
                        {text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:1,point:0}]},
            },
            {
                name:'多选文本',
                icon:'',
                i_icon:'\ue737',
                class:'',
                template:{text:"",type:"多选文本",pictureUrl:"",required:true,index:"",key:0,textPoint:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:0,point:0},
                        {text:'',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:1,point:0},]},
            },
        ]
    },
    {
        name:'填空题',
        child:[
            {
                name:'填空题',
                icon:'',
                i_icon:'\ue717',
                class:'my_span3',
                template:{text:"",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'text',nextQuestionId:'',key:0,point:0}]},
            },
        ]
    },
    {
        name:'个人信息',
        child:[
            {
                name:'姓名',
                icon:'',
                i_icon:'\ue62a',
                class:'my_span2',
                template:{text:"姓名",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'text',nextQuestionId:'',key:0,point:0}]},
            },
            {
                name:'手机',
                icon:'',
                i_icon:'\ue62c',
                class:'my_span2',
                template:{text:"手机",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'phone',nextQuestionId:'',key:0,point:0}]},
            },
            {
                name:'邮箱',
                icon:'',
                i_icon:'\ue62d',
                class:'my_span2',
                template:{text:"邮箱",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'email',nextQuestionId:'',key:0,point:0}]},
            },
            {
                name:'性别',
                icon:'',
                i_icon:'\ue62e',
                class:'my_span2',
                template:{text:"性别",type:"单选",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'男',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:0,point:0},
                        {text:'女',pictureUrl:'',index:'',format:'',nextQuestionId:'',key:1,point:0}]},
            },
            {
                name:'日期',
                icon:'',
                i_icon:'\ue61d',
                class:'my_span2',
                template:{text:"日期",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'date',nextQuestionId:'',key:0,point:0}]},
            },
            {
                name:'时间',
                icon:'',
                i_icon:'\ue632',
                class:'my_span2',
                template:{text:"时间",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'time',nextQuestionId:'',key:0,point:0}]},
            },
            {
                name:'年龄',
                icon:'',
                i_icon:'\ue628',
                class:'my_span2',
                template:{text:"年龄",type:"文本",pictureUrl:"",required:true,index:"",key:0,
                    optionList:[{text:'',pictureUrl:'',index:'',format:'point',nextQuestionId:'',key:0,point:0}]},
            },
        ]
    }
]

export const format_List = [
    {id:'text',name:'文本'},
    {id:'point',name:'数组'},
    {id:'email',name:'邮箱'},
    {id:'phone',name:'手机号码'},
    {id:'time',name:'时间'},
    {id:'date',name:'日期'}
    ]

